import React from "react";
import { Box, Grid, Button } from "@material-ui/core";
import { useHeaderStyles, LogInButton, JoinButton } from "./style";
import { Link } from "react-scroll";
import Signup from "../Signup";

const Nav = () => {
  const classes = useHeaderStyles();
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container>
        <Grid item md={6}>
          <LogInButton>Log In</LogInButton>
        </Grid>
        <Grid item md={6}>
          {/* <JoinButton>Join for free</JoinButton> */}
          {/* <Link to="section1" smooth={true} duration={500}> */}
          {/* <JoinButton>Start your journey</JoinButton> */}
          <Signup />
          {/* </Link> */}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Nav;
